// Archive-branch identity constants. The boundary matches the importer's
// config/archiveBoundary.js — duplicated here only because the frontend
// cannot import backend config; the number is frozen, so drift is not a risk
// the way live numbers drift.
export const ARCHIVE_CUTOFF_CLAIM_NUMBER = 71511;
export const ARCHIVE_TITLE = "ClaimsDesk Archive";
